/**
 * Daftar file logo partner yang ada di public/images/partners/
 * Sesuai dengan file yang benar-benar ada di folder tersebut
 */
export const partnerLogos = [
  'Aqua.png',
  'Aruba.png',
  'Axonius.png',
  'Check-Point.png',
  'Cisco.png',
  'corelight.png',
  'corsight.png',
  'CrowdStrike.png',
  'Cyberark.png',
  'Dell.png',
  'elastic.png',
  'entrust.png',
  'extrahop.webp',
  'f5.png',
  'Forcepoint.png',
  'fortinet.png',
  'group_ib.png',
  'hpe.png',
  'huawei.png',
  'imperva.jpg',
  'infoblox.png',
  'juniper.png',
  'kaytus.png',
  'Lenovo.png',
  'netapp.png',
  'NetScout.png',
  'Oracle.png',
  'paloalto.png',
  'Pentera.png',
  'Proofpoint.png',
  'purestorage.png',
  'recordedfuture.png',
  'Rubrik.png',
  'sailpoint.png',
  'sangfor.png',
  'SentinelOne.png',
  'Silverfort.png',
  'solarwinds.png',
  'sonatype.png',
  'sophos.webp',
  'supermap.png',
  'Tenable.png',
  'vectra.png',
  'Veeam.png',
  'vicarius.png',
  'vmware.png',
  'xfusion.webp',
  'Zimbra.png',
];
